/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './deleteRecord.defs'
export { main as default } from './deleteRecord.defs'
